import React, { useState, useEffect } from 'react';

import './config/reactotronConfig';
import GlobalStyle, { Header, ProjectList } from './styles/global';
import ProjectItem from './components/ProjectItem';
import Pagination from './components/Pagination';
import api from './services/api';
import logo from './assets/logo.svg';

function App() {
    const [projects, setProjects] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);

    const [itemsPerPage] = useState(8);

    async function loadProjects() {
        const { data } = await api.get('users/oneil-marcelo/repos');

        const repos = data.map(item => ({
            id: item.id,
            name: item.name.split('-')[0],
            surname: item.name.split('-')[1],
            fullname: item.name.replace('-', ' '),
            description: item.description,
            uri_repository: item.html_url,
            uri_liveview: item.homepage,
            technologies: item.topics.map(topic => topic.replace(/-/g, ' ')),
            theme: item.language ? item.language.toLowerCase() : 'default',
        }));

        setProjects(repos);
    }

    useEffect(() => {
        loadProjects();
    }, []);

    // get current Projects
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = projects.slice(indexOfFirstItem, indexOfLastItem);

    // change page
    const paginate = pageNumber => setCurrentPage(pageNumber);

    return (
        <>
            <Header>
                <img src={logo} alt="LAB" />
            </Header>
            <ProjectList>
                {currentItems.map(itemPage => (
                    <ProjectItem key={String(itemPage.id)} project={itemPage} />
                ))}
            </ProjectList>
            {projects.length > itemsPerPage ? (
                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={projects.length}
                    paginate={paginate}
                />
            ) : null}
            <GlobalStyle />
        </>
    );
}

export default App;
